// extracted by mini-css-extract-plugin
export default {"FloatingActionButton":"AddShipmentButton_FloatingActionButton__OCp-1","Text":"AddShipmentButton_Text__WGOic"};